import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'
import { useDareCard } from 'root/src/client/web/list/listItemComponents/dare/hooks/useDareCard'
import classNames from 'classnames'
import { DareCardTypeIcon } from 'root/src/client/web/list/listItemComponents/project/ProjectCardCircleImage'
import {
	categoriesMap,
	colorsNew,
} from 'root/src/client/web/commonStyles'
import { readableDropDareTypes } from 'root/src/shared/constants/dropEvent'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'

export const DareCardSeparator = withProjectCardStyle(({ classes }) => {
	const {
		dare: { level, type },
		extraData: {
			brand,
		},
	} = useDareCard()
	return (
		<div className={classNames(
			'layout-row layout-align-center',
			classes.projectAssigne,
			classes.overlay,
		)}
		>
			<DareCardTypeIcon
				icon={categoriesMap[type].icon}
				alt={brand.brandName}
			/>
			<div className={classes.namesContainer}>
				<p className={classes.assigneesNames}>
					{readableDropDareTypes[type]}
				</p>
				<div style={{ display: 'flex', flexDirection: 'column', fontSize: 12, alignItems: 'center', justifyContent: 'center' }}>
					<Typography
						color={colorsNew.light4}
						variant={typographyVariants.microBold}
					>
						DIFFICULTY
					</Typography>
					<Typography className={classes.uppercase} variant={typographyVariants.mini}>
						{level}
					</Typography>
				</div>
			</div>
		</div>
	)
})
